document.addEventListener("DOMContentLoaded", function () {
  function aplicarMargemSomenteSemRating() {
    document.querySelectorAll(".card-information").forEach(function (card) {
      const title = card.querySelector(".wrapper-title");
      const reviewsContainer = card.querySelector(".konfidency-reviews-multi");

      // Se houver .rating dentro de .konfidency-reviews-multi, não aplica margem
      const temRating = reviewsContainer?.querySelector(".rating");

      if (!temRating && title && !title.classList.contains("ajustado")) {
        title.style.marginTop = "32px";
        title.classList.add("ajustado");
      }
    });
  }

  // Aguarda o app de avaliação renderizar o conteúdo
  setTimeout(() => {
    aplicarMargemSomenteSemRating();
  }, 1500); // Tempo suficiente para o JS do app rodar
});
